export default {
  "app.title": "AICOS",
  "app.tagline": "Financials",
  "nav.dashboard": "Dashboard",
  "nav.gl": "General Ledger",
  "nav.ar": "Receivables",
  "nav.ap": "Payables",
  "nav.tax": "Tax",
  "auth.signIn": "Sign in",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.signOut": "Sign out",
  "auth.invalid": "Invalid email or password",
  "auth.signedInAs": "Signed in as",
  "dashboard.welcome": "Welcome to AICOS",
  "nav.bi": "Billing",
  "nav.po": "Purchasing",
  "nav.ex": "Expenses",
  "nav.entities": "Entities",
  "dashboard.subtitle": "Operator console — every module action, wired to AICOS.",
  "nav.ceo": "CEO Cockpit",
  "nav.cfo": "CFO Corner",
  "kpi.days": "days",
  "nav.compliance": "Compliance",
  "brand.org": "Lopettia",
  "brand.product": "AICOS",
  "nav.home": "Home",
  "app.system": "AI Corporate Operating System",
  "home.selectModule": "Select a module",
  "soon.title": "Coming soon",
  "soon.body": "This function is part of the legacy AICOS parity scope and is not yet wired in the Go rewrite. It remains available in the legacy AICOS.",
  "mod.ap": "Accounts Payable",
  "mod.ar": "Accounts Receivable",
  "mod.ex": "Travel & Expense",
  "hub.journals": "Journals",
  "hub.reports": "Balances & reports",
  "hub.closing": "Closing",
  "hubd.newJournal": "Create and edit manual journals",
  "hubd.journals": "Post, approve and reverse",
  "hubd.trialBalance": "Account balances for the year",
  "hubd.statements": "Balance sheet and income statement",
  "hubd.yearEnd": "Year-end close process",
  "hubd.payables": "Enter and post a vendor bill",
  "hubd.payablesList": "Posted vendor bills",
  "hubd.receivables": "Raise a customer invoice",
  "hubd.openItems": "Outstanding receivables",
  "hubd.payment": "Receive and apply a payment",
  "hubd.billing": "Issue a sales invoice with GST",
  "hubd.invoices": "Issued sales invoices",
  "hubd.purchasing": "Raise a purchase order",
  "hubd.orders": "Open purchase orders",
  "hubd.match": "3-way match to AP",
  "hubd.expenses": "Submit an expense report",
  "hubd.expenseList": "Approve and post reports",
  "kpi.revenue_ytd": "Revenue YTD",
  "kpi.expenses_ytd": "Expenses YTD",
  "kpi.net_income": "Net income",
  "kpi.operating_margin_pct": "Operating margin",
  "kpi.gross_margin_pct": "Gross margin",
  "kpi.cash_position": "Cash position",
  "kpi.ar_balance": "Accounts receivable",
  "kpi.ap_balance": "Accounts payable",
  "kpi.gst_net_owing": "Net GST owing",
  "kpi.working_capital": "Working capital",
  "kpi.current_ratio": "Current ratio",
  "kpi.dso_days": "DSO",
  "kpi.dpo_days": "DPO",
  "kpi.dio_days": "DIO",
  "kpi.ccc_days": "Cash conversion cycle",
  "kpi.revenue_mtd": "Revenue MTD",
  "kpi.bills_mtd_count": "Bills this month",
  "kpi.pipeline_value": "Pipeline value",
  "kpi.concentration_top1_pct": "Top-customer concentration",
  "kpi.active_business_units": "Active business units",
  "kpi.active_users": "Active users",
  "kpi.risk_score": "Open audit findings",
  "kpi.top_customers": "Top customers",
  "kpi.geographic_top": "Top region",
  "dash.openItemsFor": "Open items — {id}",
  "dash.openFindings": "Open audit findings",
  "common.date": "Date",
  "common.currency": "Currency",
  "common.description": "Description",
  "common.amount": "Amount",
  "common.account": "Account",
  "common.debit": "Debit",
  "common.credit": "Credit",
  "common.status": "Status",
  "common.actions": "Actions",
  "common.customer": "Customer",
  "common.vendor": "Vendor",
  "common.total": "Total",
  "common.calculate": "Calculate",
  "common.result": "Result",
  "common.rate": "Rate",
  "common.language": "Language",
  "common.noData": "No data.",
  "common.selectAccount": "Select account…",
  "common.selectCustomer": "Select customer…",
  "common.selectVendor": "Select vendor…",
  "common.remove": "Remove",
  "gl.tab.entry": "New journal",
  "gl.tab.journals": "Journals",
  "gl.tab.balances": "Balances",
  "gl.tab.reports": "Reports",
  "gl.tab.yearend": "Year-end",
  "gl.yearEnd": "Year-end close",
  "gl.previewClose": "Preview close",
  "gl.executeClose": "Execute close",
  "gl.closingLines": "closing lines",
  "gl.closed": "FY {fy} closed (journal {id}).",
  "gl.exportCsv": "Export CSV",
  "common.fiscalYear": "Fiscal year",
  "gl.descrPlaceholder": "e.g. Monthly consulting revenue",
  "gl.addLine": "+ Add line",
  "gl.balanced": "Balanced",
  "gl.outOfBalance": "Out of balance: {diff}",
  "gl.saveDraft": "Save draft",
  "gl.postJournal": "Post journal",
  "gl.posted": "Journal {id} posted.",
  "gl.savedDraft": "Journal {id} saved as draft.",
  "gl.approved": "Journal {id} approved.",
  "gl.col.journal": "Journal",
  "gl.noJournals": "No journals yet. Create one under “New journal”.",
  "gl.post": "Post",
  "gl.approve": "Approve",
  "gl.reverse": "Reverse",
  "gl.reversed": "Journal {id} reversed.",
  "gl.reverseReason": "Reason for reversal (min 10 chars)",
  "common.cancel": "Cancel",
  "gl.balancesTitle": "Account balances (FY {fy})",
  "gl.noBalances": "No posted balances yet.",
  "gl.col.debits": "Debits",
  "gl.col.credits": "Credits",
  "gl.col.balance": "Balance",
  "gl.balanceSheet": "Balance sheet (FY {fy})",
  "gl.incomeStatement": "Income statement (FY {fy})",
  "gl.assets": "Assets",
  "gl.totalAssets": "Total assets",
  "gl.liabilities": "Liabilities",
  "gl.equity": "Equity",
  "gl.netIncomeYear": "Current-year net income",
  "gl.totalLiabEquity": "Total liabilities & equity",
  "gl.isBalanced": "✓ Balanced",
  "gl.notBalanced": "⚠ Out of balance",
  "gl.revenue": "Revenue",
  "gl.totalRevenue": "Total revenue",
  "gl.expenses": "Expenses",
  "gl.totalExpenses": "Total expenses",
  "gl.netIncome": "Net income",
  "ar.newInvoice": "New customer invoice",
  "ar.createInvoice": "Create invoice",
  "ar.created": "Invoice {id} created.",
  "ar.openItems": "Open items",
  "ar.noItems": "No open items.",
  "ar.openItem": "Open item",
  "ar.selectItem": "Select an item",
  "ar.paymentAmount": "Payment amount",
  "ar.cashAccount": "Cash account",
  "ar.receivePayment": "Receive payment",
  "ar.receiveApply": "Receive & apply",
  "ar.paymentPosted": "Payment applied to {id}.",
  "ar.col.item": "Item",
  "ar.col.balance": "Balance",
  "ap.enterBill": "Enter a bill",
  "ap.vendorInvoice": "Vendor invoice #",
  "ap.expenseAccount": "Expense account",
  "ap.enterPost": "Enter & post bill",
  "ap.posted": "Bill {id} entered and posted.",
  "ap.bills": "Bills",
  "ap.noBills": "No bills.",
  "ap.col.voucher": "Voucher",
  "ap.col.gross": "Gross",
  "ap.col.net": "Net",
  "bi.issueInvoice": "Issue a sales invoice",
  "bi.revenueAccount": "Revenue account",
  "bi.amountBeforeTax": "Amount (before tax)",
  "bi.gst": "GST/HST",
  "bi.issue": "Issue invoice",
  "bi.issued": "Invoice {id} issued (posts to revenue + opens a receivable).",
  "bi.invoices": "Invoices",
  "bi.noInvoices": "No invoices.",
  "bi.col.invoice": "Invoice",
  "ex.newReport": "New expense report",
  "ex.employee": "Employee",
  "ex.employeePlaceholder": "Employee ID",
  "ex.purpose": "Purpose",
  "ex.submit": "Submit report",
  "ex.approve": "Approve",
  "ex.approved": "Report {id} approved.",
  "ex.post": "Post",
  "ex.posted": "Report {id} posted.",
  "ex.submitted": "Expense report {id} submitted (approve, then post under Journals).",
  "ex.reports": "Reports",
  "ex.noReports": "No expense reports.",
  "ex.col.report": "Report",
  "ex.col.reimbursable": "Reimbursable",
  "po.newOrder": "New purchase order",
  "po.quantity": "Quantity",
  "po.unitPrice": "Unit price",
  "po.create": "Create PO",
  "po.created": "Purchase order {id} created.",
  "po.orders": "Purchase orders",
  "po.noOrders": "No purchase orders.",
  "po.receive": "Receive",
  "po.received": "Received goods for PO {po}.",
  "po.noLines": "This PO has no lines.'",
  "po.col.po": "PO",
  "po.col.match": "Match",
  "po.threeWayMatch": "3-way match",
  "po.matchResult": "PO {po}: {status}.",
  "ent.title": "Reference data",
  "ent.chartOfAccounts": "Chart of accounts",
  "ent.customers": "Customers",
  "ent.vendors": "Vendors",
  "ent.currencies": "Currencies",
  "ent.provinces": "Provinces",
  "ent.noRows": "No rows.",
  "ent.new": "New record",
  "ent.create": "Create",
  "ent.created": "Record created.",
  "ent.delete": "Delete",
  "ent.deleted": "Record deleted.",
  "ent.confirmDelete": "Delete this record?",
  "ent.grp.master": "Master data",
  "ent.grp.collections": "AR collections",
  "ent.grp.expense": "Expense detail",
  "ent.grp.compliance": "Compliance & disclosure",
  "ent.arWriteoffs": "AR write-offs",
  "ent.arAllowance": "AR allowance (CECL)",
  "ent.dunning": "Dunning letters",
  "ent.travelAuth": "Travel authorizations",
  "ent.cashAdvance": "Cash advances",
  "ent.auditFindings": "Internal-audit findings",
  "ent.legalHold": "Legal holds",
  "ent.consolidation": "Consolidation eliminations",
  "tax.title": "Tax — Canada (Alberta)",
  "tax.tab.gst": "GST calculator",
  "tax.tab.return": "GST/HST return",
  "tax.tab.rates": "Rates",
  "tax.calcTitle": "Calculate GST / HST",
  "tax.amountBeforeTax": "Amount (before tax)",
  "tax.province": "Province",
  "tax.transaction": "Transaction",
  "tax.txSale": "Sale (collect GST)",
  "tax.txPurchase": "Purchase (input tax credit)",
  "tax.supply": "Supply",
  "tax.domestic": "Domestic",
  "tax.export": "Export to non-resident",
  "tax.taxClass": "Tax class",
  "tax.itc": "Input tax credit",
  "tax.yes": "Yes (recoverable)",
  "tax.no": "No",
  "tax.returnTitle": "GST/HST return",
  "tax.english": "English",
  "tax.french": "Français",
  "tax.line": "Line {n} — {label}",
  "tax.netTax": "Net tax",
  "tax.ratesTitle": "Canadian sales-tax rates",
  "tax.col.gstHst": "GST/HST",
  "tax.col.pst": "PST",
  "tax.col.type": "Type",
  "comp.amount": "Amount",
  "comp.grossAmount": "Gross amount",
  "comp.province": "Province",
  "comp.transaction": "Transaction",
  "comp.supply": "Supply",
  "comp.class": "Class",
  "comp.concept": "Concept",
  "comp.municipality": "Municipality",
  "comp.taxableIncome": "Taxable income",
  "comp.tariff": "Tariff",
} as Record<string, string>;
